import PropTypes from 'prop-types';
import React from 'react';

import { hexToRGB } from '../../../../utils/hexToRGB';

import * as S from './Tabs.styles';

export const Tabs = ({ tabs, setCurrentTab, currentTab }) => {
  if (!tabs) {
    return null;
  }

  return (
    <S.TabList>
      {tabs.map((tab, index) => {
        const {
          interactive_horizontal_persona: persona,
          interactive_horizontal_color: color,
        } = tab || '';

        const isCurrentTab = currentTab === index;
        const colorRGB = hexToRGB(color, 0.05);

        if (!persona) {
          return null;
        }

        return (
          <S.TabName
            colorRGB={colorRGB}
            customColor={color}
            isCurrentTab={isCurrentTab}
            key={`${tab}-${index}`}
            onClick={() => setCurrentTab(index)}
          >
            {persona}
          </S.TabName>
        );
      })}
    </S.TabList>
  );
};

Tabs.propTypes = {
  currentTab: PropTypes.number,
  setCurrentTab: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      interactive_horizontal_persona: PropTypes.string,
      interactive_horizontal_color: PropTypes.string,
    })
  ).isRequired,
};
